import {Component, OnInit, ViewChild} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import {ValidValuesService} from './valid-values.service';
import {MatDialog} from '@angular/material/dialog';
import {EnumValidValueModel} from '../../../models/enum/enum-valid-value.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {ColorSchemesService} from '../color-schemes/color-schemes.service';
import {ColorSchemeDataModel} from '../../../models/configuration/color-scheme-data.model';
import {TdoColorSchemePickerEvent} from '../../../tdo-controls/common/tdo-color-scheme-picker/models/tdo-color-scheme-picker.event';
import {TdoImagePickerEvent} from '../../../tdo-controls/common/tdo-image-picker/model/tdo-image-picker.event';
import {StaticDataService} from '../../../services/static-data.service';
import {DialogService} from '../../../services/dialog.service';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {MatCheckboxChange} from '@angular/material/checkbox';
import { MessagingConstants } from 'src/app/models/MessagingConstants';
import { MessagingService } from 'src/app/services/messaging.service';

//import { DxTreeViewModule } from 'devextreme-angular';


@Component({
  selector: 'app-valid-values',
  templateUrl: './valid-values.component.html',
  styleUrls: ['./valid-values.component.scss']
})
export class ValidValuesComponent implements OnInit { 
  @ViewChild('grid') dataGrid: DxDataGridComponent;
  @ViewChild('vvTable') vvTable: TdoTableV2Component;
  @ViewChild('itemTable') itemTable: TdoTableV2Component;

  validValuesList: EnumValidValueModel[];
  selectedValidValueItem: EnumValidValueItemModel;
  isLoading: boolean = false;


  isShowEdit : boolean = true;
  isShowNew : boolean = false;
  isSaveHidden: boolean= true;
  isShowCancel : boolean = false;


  imageDataSource = ['iconToothNew.svg', 'iconMedicalChair.svg', 'iconDoctorNew.svg', 'iconMicroscope.svg', 'iconMedicalBag.svg', 'iconNoLatex.svg',
  'form-need-signature.svg', 'form-signed.svg', 'form-complete.svg', 'form-incomplete.svg', 'balance-due.svg', 'expired-forms.svg', 'premedicate.svg',
    'send-sms.svg', 'send-email.svg', 'nos.svg', 'antibiotic.svg', 'medical-history-filled.svg', 'medical-history-not-filled.svg', 'anxiety.svg',
    'emergency.svg', 'sedation.svg', 'confirmation.svg', 'web-registration.svg'
  ];

  colorSchemes: ColorSchemeDataModel[];

  private _selectedValidValue: EnumValidValueModel;

  constructor(
    private validvalueService: ValidValuesService,
    private colorSchemeService: ColorSchemesService,
    private dialog: MatDialog,
    private messagingService: MessagingService,
    private staticDataService: StaticDataService,
    private dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    // this.getValuesList();
    console.log("ValidValuesComponent ngOnInit");

    this.colorSchemeService.getColorSchemes().subscribe((data) => {
      this.colorSchemes = data;
      this.staticDataService.getAllValidValues().subscribe((values) => {
        this.validValuesList = values;

        this.validValuesList = values.sort((a, b) => {
          const a1 = a.ValidValueName.toUpperCase();
          const b1 = b.ValidValueName.toUpperCase();
          return (a1 < b1) ? -1 : (a1 > b1) ? 1 : 0;
        });

        this.refreshValidValueTableViewData();
        this.selectedValidValue = this.validValuesList[0];
        this.selectedValidValue.enumValidValueItems = this.selectedValidValue.enumValidValueItems.sort((a, b) => {
          return a.ItemOrder - b.ItemOrder;
        });

        const ivl = setInterval(() => {
          if (!this.itemTable) {
            return;
          }
          clearInterval(ivl);
          this.itemTable.updateData(this.selectedValidValue.enumValidValueItems);
        }, 1);
      });
    });
  }

  refreshValidValueTableViewData(setItemEditMode: EnumValidValueModel = null) {
    if (this.vvTable) {
      this.vvTable.updateData(this.validValuesList);
    }
  }

  refreshValidValueItemTableViewData(items: EnumValidValueItemModel[] = null) {
    const ivl = setInterval(() => {
      if (!this.itemTable) {
        return;
      }
      clearInterval(ivl);
      if (items) {
        this.itemTable.updateData(items);
      } else {
        this.itemTable.updateData(this.selectedValidValue.enumValidValueItems);
      }
    }, 10);
  }

  confirm(message) {
    if (this.selectedValidValue.ValidValueId !== '') {
      this.dialogService.openConfirmDialog(message).subscribe((result) => {
        if (result === true) {
          this.isLoading = true;
          this.validvalueService.callUpdateenumValidValue(this.selectedValidValue.ValidValueId)
            .subscribe(response => {
              this.isLoading = false;
              // this.getValuesList();
            });
        } else {
          // they pressed cancel
        }
      });
    }
  }

  get selectedValidValue() {
    return this._selectedValidValue;
  }

  set selectedValidValue(value: EnumValidValueModel) {
    this._selectedValidValue = value;
    if (value.enumValidValueItems) {
      if (value.enumValidValueItems.length > 0) {
        this.selectedValidValueItem = this.selectedValidValue.enumValidValueItems[0];
      }
      this.refreshValidValueItemTableViewData();
    }
  }

  onSchemeChange(event: TdoColorSchemePickerEvent) {
    this.selectedValidValueItem.ColorSchemeId = event.value.ColorSchemeId;
    this.saveValidValueItem(this.selectedValidValueItem);
  }

  saveValidValue() {
    if (this.selectedValidValue) {
      this.validvalueService.saveValidValue(this.selectedValidValue).subscribe((data) => {
        //
        this.selectedValidValue = data;
        if (!this.selectedValidValue.enumValidValueItems) {
          this.selectedValidValue.enumValidValueItems = [];
        }
        console.log("saveValidValue event MessagingConstants.VALID_VALUES_REFRESH");
        this.messagingService.sendParentMessage(MessagingConstants.VALID_VALUES_REFRESH, {});

      });
    }
  }

  saveValidValueItem(item: EnumValidValueItemModel, isNew: boolean = false) {
    this.validvalueService.saveValidValueItem(item).subscribe((ret) => {
      this.selectedValidValueItem.ValidValueItemId = ret.ValidValueItemId;
      //const idx = this.selectedValidValue.enumValidValueItems.findIndex(p => p.ItemName === ret.ItemName || p.ValidValueItemId === ret.ValidValueItemId);
      const idx = this.selectedValidValue.enumValidValueItems.findIndex(p =>  p.ValidValueItemId === ret.ValidValueItemId);
      this.selectedValidValue.enumValidValueItems[idx] = ret;

      console.log("saveValidValueItem event MessagingConstants.VALID_VALUES_REFRESH");
      this.messagingService.sendParentMessage(MessagingConstants.VALID_VALUES_REFRESH, {});


      if (isNew) {
        this.refreshValidValueItemTableViewData();
      } else {
        this.refreshValidValueItemTableViewData();
      }
    });
  }

  onImageChange(event: TdoImagePickerEvent) {
    this.selectedValidValueItem.IconIDSVG = event.imageName;
    this.saveValidValueItem(this.selectedValidValueItem);
  }


  onNewValidValue() {
    const model = new EnumValidValueModel();
    this.validValuesList.unshift(model);
    this.refreshValidValueTableViewData(model);

  }

  onNewValidValueItem() {
    const model = new EnumValidValueItemModel();
    model.ValidValueId = this.selectedValidValue.ValidValueId;
    model.ColorSchemeId = null;
    model.IconIDSVG = null;
    model.ItemDisplayValue = '';
    model.ItemName = this.selectedValidValue.ValidValueName + '.';
    model.ItemSValue = '';
    model.isSystem = false;
    model.ItemOrder = this.selectedValidValue.enumValidValueItems.length;
    model.xauditDeleted=false;
    this.selectedValidValue.enumValidValueItems.push(model);
    
    this.saveValidValueItem(model, true);
    this.refreshValidValueItemTableViewData(this.selectedValidValue.enumValidValueItems);

  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.selectedValidValue = event.row.model as EnumValidValueModel;
    this.selectedValidValue.enumValidValueItems = this.selectedValidValue.enumValidValueItems.sort((a, b) => {
      return a.ItemOrder - b.ItemOrder;
    });
    const ivl = setInterval(() => {
      if (!this.itemTable) {
        return;
      }
      clearInterval(ivl);
      this.itemTable.updateData(this.selectedValidValue.enumValidValueItems);
    }, 100);
  }

  onDeleteValidValue(model: EnumValidValueModel) {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.ValidValueName}?`).subscribe((result) => {
      if (result === true) {
        this.validvalueService.deleteValidValue(model).subscribe(res => {
          const idx = this.validValuesList.findIndex(p => p.ValidValueId === model.ValidValueId);
          if (idx > -1) {
            this.validValuesList.splice(idx, 1);
            this.refreshValidValueTableViewData();
          }
        });
      } else {
        //
      }
    });
  }

  changeValidValueisSystem(event: MatCheckboxChange)  {
    this.selectedValidValue.isSystem  =  event.checked;
    this.saveValidValue();

  }

  onSystemChange(event: MatCheckboxChange, model: EnumValidValueItemModel) {
    model.isSystem = event.checked;
    this.saveValidValueItem(model);
  }

  onItemRowSelected(event: TdoTableSelectionEvent) {
    this.selectedValidValueItem = event.row.model as EnumValidValueItemModel;
  }

  onDeleteItem(model: EnumValidValueItemModel) {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.ItemName}?`).subscribe((result) => {
      if (result === true) {
        this.validvalueService.deleteValidValueItem(model).subscribe((response) => {
          const idx = this.selectedValidValue.enumValidValueItems.findIndex(p => p.ValidValueItemId === response.ValidValueItemId);
          if (idx > -1) {
            this.selectedValidValue.enumValidValueItems.splice(idx, 1);
            if (this.selectedValidValue.enumValidValueItems.length > 0) {
              //
            } else {
              this.selectedValidValueItem = null;
            }
            this.refreshValidValueItemTableViewData();
          }
        });
      } else {
        //
      }
    });
  }

  onItemsReordered($event: void) {
    
    
    let i = 1;
    for (const item of this.itemTable.matDataSource.data) {
      item.model.ItemOrder = i;
      i++;
    }

    this.selectedValidValue.enumValidValueItems = this.itemTable.matDataSource.data.map(p => p.model);
    this.staticDataService.reorderValidValueItems(this.selectedValidValue.enumValidValueItems).subscribe((res) => {
      // this.selectedValidValue.enumValidValueItems = res;
    });


  }
}
